// EVENTS.COMPONENTS.APPLICATION.REWARDS.EARN.MORE_INFO_MODAL

export const MORE_INFO_MODAL = {
  ACTION_BUTTON: 'achievement-actioned_button'
};
